
// import "./endPoint.scss";
import pinIcon from '!raw-loader!../../images/interface/pictos/mapsPin.svg'
import StringUtils from '../utils/string.js'

export default class EndPoint {

  constructor(data, options) {

    this.data = data;

    this.settings = $.extend({}, {
    }, options);


    this.horaireCleaningRegexps = [
      /00h00 &agrave; 00h00/i,
      /(^\s*\/\s*|\s*\/\s*$)/i
    ];

  }

  getHoraires() {

    if (this.data.horaires === undefined) {
      return null;
    }

    let horaires = this.data.horaires;
    if (this.data.type == 'relais_colis') {
      delete horaires.xeett;
    } else if (this.data.type == 'chronorelais') {
      horaires = {
        lundi: horaires[1] !== undefined ? horaires[1] : 'Fermé',
        mardi: horaires[2] !== undefined ? horaires[2] : 'Fermé',
        mercredi: horaires[3] !== undefined ? horaires[3] : 'Fermé',
        jeudi: horaires[4] !== undefined ? horaires[4] : 'Fermé',
        vendredi: horaires[5] !== undefined ? horaires[5] : 'Fermé',
        samedi: horaires[6] !== undefined ? horaires[6] : 'Fermé',
        dimanche: horaires[7] !== undefined ? horaires[7] : 'Fermé',
      };
    }
    return horaires;
  }

  get cost() {
    return { total: this.data.cost };
  }

  get type() {
    return this.data.type;
  }

  get id_retrait() {
    return this.data.id_retrait;
  }

  get(propKey) {

    switch (propKey) {

      case 'ville':
        return this.data['localite'] === undefined
          ? this.data['ville']
          : this.data['localite'];

      case 'codePostal':
        return this.data['localite'] === undefined
          ? this.data['ville']
          : this.data['localite'];

      case 'horaires':
        return this.getHoraires();

      case 'formattedDescription':

        let $horairesList = $('<ul/>', { class: 'horaires' });
        let horaires = this.getHoraires();

        // merge horaires
        let startDay = null;
        let lastDay = null;
        let mergedHoraires = {};
        let lastHoraires = null;

        for (let day in horaires) {

          if (startDay == null) {
            startDay = day;
          }

          if (lastHoraires != null && horaires[day] != lastHoraires) {

            mergedHoraires[startDay != lastDay
              ? startDay + ' - ' + lastDay
              : startDay
            ] = lastHoraires;

            startDay = day;

          }

          lastHoraires = horaires[day];
          lastDay = day;
        }

        if (lastHoraires != null) {

          mergedHoraires[startDay != lastDay
            ? startDay + ' - ' + lastDay
            : startDay
          ] = lastHoraires;

        }

        for (let range in mergedHoraires) {

          let horaires = mergedHoraires[range];

          horaires = this.horaireCleaningRegexps.reduce((horaires, regex) => horaires.replace(regex, ''), horaires);

          $horairesList.append($('<li/>').html('<strong>' + range + '</strong> : ' + horaires));
        }

        return `<h3>${this.data.libelle}</h3>
                    <div class="right">
                        <p class="provider ${this.data.type}">${pinIcon} ${this.data.provider.label}</p>
                        <p class="shipping-date">Livraison ${this.data.provider.deliverDateLabel}</p>
                        <p class="cost">${this.cost.total ? StringUtils.toLocaleString(this.cost.total, { style: 'currency', currency: 'EUR' }) : 'Gratuit'}</p>
                    </div>
                    <p class="address">
                        <span class="street">${this.get('adresse')}</span><br/>
                        <span class="cp">${this.get('cp')}</span>
                        <span class="ville">${this.get('ville')}</span>
                    </p>
                    ` + (this.data.distance
            ? `<p class="distance">Distance : ${this.data.distance < 1
              ? (Math.round(this.data.distance * 1000 * 100) / 100) + ' m'
              : (Math.round(this.data.distance * 100) / 100) + ' km'}</p>`
            : '')

          + (horaires !== null
            ? `<p class="horaires">Horaires :</p>` + $('<div/>').append($horairesList).html()
            : '');
      case 'summary':
        return `<h4>${this.data.libelle}</h4>
          <p class="address">
            <span class="street">${this.get('adresse')}</span><br/>
            <span class="cp">${this.get('cp')}</span>
            <span class="ville">${this.get('ville')}</span>
          </p>`

      default:
        return this.data[propKey];
    }

  }

}
